import React from 'react'
import ContentLoader from 'react-content-loader'

/** Generated with http://danilowoz.com/create-content-loader/ */

const gap = 72

const ScrollListWithTitlePlaceholderItem: React.FC<{ i: number }> = ({ i }) => (
  <>
    <circle key={`circle-${i}`} cx={38 + i * gap} cy="38" r="26" />
    <rect key={`rect-${i}`} x={14 + i * gap} y="80" rx="3" ry="3" width="48" height="10" />
  </>
)

const ScrollListWithTitlePlaceholder = () => (
  <ContentLoader
    speed={2}
    width={400}
    height={101}
    viewBox="0 0 400 101"
    backgroundColor="#e6e6e6"
    foregroundColor="#cdcdcd"
  >
    {Array.from({ length: 10 }, (_, i) => (
      <ScrollListWithTitlePlaceholderItem key={`ScrollListWithTitlePlaceholderItem-${i}`} i={i} />
    ))}
  </ContentLoader>
)

export default ScrollListWithTitlePlaceholder
